import moment from "moment";
import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Select from "react-select";
import Loading from "../../../cross/Loading";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IAuditoria from "../../../entities/IAuditoria";
import IGerencia from "../../../entities/IGerencia";
import { IItemNormativaxAuditoria } from "../../../entities/IItemNormativaxAuditoria";
import IItemNormativo from "../../../entities/IItemNormativo";
import IITemNormativoActive from "../../../entities/IItemNormativoActive";
import IRequisitosNormativos from "../../../entities/IRequisitosNormativos";
import { ITipoAuditoria } from "../../../entities/ITipoAuditoria";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { RegexHelper } from "../../../helpers/regexHelper";
import { cognitoUserToken, cognitoUserInfo } from "../../../helpers/userHelper";
import {
  ROW_COUNT_MAX,
  API_AUDITORIA,
  URL_SUPPORT,
  API_ADMIN_TIPO_AUDITORIA,
  API_ADMIN_GERENCIA,
  API_ADMIN_TIPO_UNIDAD_AUDITAR,
  API_AUDITORIA_GET_AUDITORIA,
  API_ADMIN_REQ_NORMATIVOS,
  API_AUDITORIA_POST_ITEMNORMATIVO,
} from "../../../helpers/variableHelper";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AuditoriaService from "../../../services/AuditoriaService";
const MySwal = withReactContent(Swal);

interface IFormItemNormativaProps {
  isOpen: boolean;
  idAuditoria: number;
  callBack: () => void;
  callBackClose: () => void;
  selectedItemNormativo?: IItemNormativo | IItemNormativaxAuditoria | null;
  createdItemNormativo?: IITemNormativoActive | null;
  loading?: boolean;
  is_test?: boolean;
  id?: string;
}
export default function FormItemNormativa({
  isOpen,
  idAuditoria,
  callBack,
  callBackClose,
  selectedItemNormativo,
  createdItemNormativo,
  is_test,
  loading = true,
}: IFormItemNormativaProps) {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [isSendingData, setIsSendingData] = useState(false);

  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState<IAuditoria | null>(null);
  const [allTipoAuditoria, setAllTipoAuditoria] = useState<Array<ITipoAuditoria>>([]);
  const [allGerencia, setAllGerencia] = useState<Array<IGerencia>>([]);
  const [allUnidadAuditar, setAllUnidadAuditar] = useState<Array<ITipoUnidadAuditar>>([]);
  const [requisitoNormativoAuditoria, setRequisitoNormativoAuditoria] = useState<Array<IRequisitosNormativos>>([]);
  const refTxtPredio = React.createRef<HTMLTextAreaElement>();
  const refTxtFecha = React.createRef<HTMLInputElement>();
  const refTxtHoraDesde = React.createRef<HTMLInputElement>();
  const refTxtHoraHasta = React.createRef<HTMLInputElement>();
  const refTxtObservaciones = React.createRef<HTMLTextAreaElement>();

  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [lenTxtPredio, setLenTxtPredio] = useState<number>(0);
  const [lenTxtObservaciones, setLenTxtObservaciones] = useState<number>(selectedItemNormativo?.OBSERVACIONES.length || 0);
  let paramsActive = {
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
    ORDENADOPOR: "ID",
    ORIENTACION: "ASC",
    ACTIVO: true,
  };

  usePromiseEffect(async () => {
    // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del formulario de item normativo
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(true);

    let resultAllTipoAuditoria: Array<ITipoAuditoria> = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setAllTipoAuditoria(resultAllTipoAuditoria);

    if (idAuditoria) {
      let resultGetAuditoria: IAuditoria = is_test
        ? {
            VICEPRESIDENCIA: "",
            GERENCIA_SUBGERENCIA: "",
            AUDITOR_EXTERNO: true,
            ID_TIPO_AUDITORIA: 1,
            UNIDAD_A_AUDITAR: [1],
            ID_VICEPRESIDENCIA: 1,
            ID_GERENCIA_SUBGERENCIA: 1,
            RESPONSABLE_AREA: "",
            RESPONSABLE_AREA_DISPLAY: "",
            AUDITOR_LIDER: "",
            AUDITOR_LIDER_DISPLAY: "",
            AUDITORES_ACOMPANANTES: "",
            AUDITORES_ACOMPANANTES_DISPLAY: "",
            NOMBRE_AUDITOR_EXTERNO: "",
            PREDIO_RECINTO: [""],
          }
        : (await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: idAuditoria })).result;

      let resultAllFilterGerencia = is_test
        ? { data: [] }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...paramsActive,
                VICEPRESIDENCIA: resultGetAuditoria.VICEPRESIDENCIA,
              }
            )
          ).result;
      setAllGerencia(resultAllFilterGerencia.data);
      setAuditoriaSeleccionada(resultGetAuditoria);

      setLenTxtPredio(
        selectedItemNormativo?.PREDIO_RECINTO.length ||
          `${auditoriaSeleccionada?.GERENCIA_SUBGERENCIA}\n${auditoriaSeleccionada?.UNIDAD_PROYECTO}`.length ||
          0
      );

      let resultAllUnidadAuditar = is_test
        ? { data: [] }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...paramsActive,
                TIPO_AUDITORIA: resultAllTipoAuditoria.filter((ta) => ta.ID === resultGetAuditoria.ID_TIPO_AUDITORIA)[0].NOMBRE,

                ACTIVO: true,
              }
            )
          ).result;
      setAllUnidadAuditar(resultAllUnidadAuditar.data);

      let resultRequisitoNormativoAuditoria = is_test
        ? { data: [] }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...paramsActive,
                ACTIVO: true,
              }
            )
          ).result;
      setRequisitoNormativoAuditoria(resultRequisitoNormativoAuditoria.data);
      resultAllUnidadAuditar.data.filter(
        (ua: any) =>
          resultGetAuditoria?.UNIDAD_A_AUDITAR.includes(ua.ID as number) &&
          resultRequisitoNormativoAuditoria.data.filter((rna: any) => rna.UNIDAD_AUDITAR === ua.NOMBRE).length > 0
      );
    }

    setIsLoading(false);
  }, []);

  const formValidation = (value: Partial<IItemNormativo>): boolean => {
    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];
    if (!value.REQUISITOS_NORMATIVOS?.length && selectedItemNormativo === null) {
      arrErrors.push("REQUISITOS_NORMATIVOS");
    }
    if (!value.PREDIO_RECINTO) {
      arrErrors.push("PREDIO_RECINTO");
    }
    if (!moment(value.FECHA).isValid()) {
      arrErrors.push("FECHA");
    }
    if (!value.HORA_INICIO) {
      arrErrors.push("HORA_INICIO");
    }
    if (value.HORA_INICIO && !RegexHelper.validateTime(value.HORA_INICIO)) {
      arrErrors.push("HORA_INICIO");
      arrErrorsText.push("Debe ingresar una hora de inicio válida");
    }
    if (!value.HORA_FINAL) {
      arrErrors.push("HORA_FINAL");
    }
    if (value.HORA_FINAL && !RegexHelper.validateTime(value.HORA_FINAL)) {
      arrErrors.push("HORA_FINAL");
      arrErrorsText.push("Debe ingresar una hora de fin válida");
    }
    if (value.HORA_INICIO && value.HORA_FINAL) {
      let fInicio = moment(`${moment(value.FECHA).format("YYYY-MM-DD")} ${value.HORA_INICIO}`);
      let fFinal = moment(`${moment(value.FECHA).format("YYYY-MM-DD")} ${value.HORA_FINAL}`);
      if (
        moment(value.FECHA).isValid() &&
        RegexHelper.validateTime(value.HORA_INICIO) &&
        RegexHelper.validateTime(value.HORA_FINAL) &&
        fInicio >= fFinal
      ) {
        arrErrors.push("HORA_INICIO");
        arrErrorsText.push("La hora de inicio debe ser menor que la hora final");
      }
    }

    if (!value.OBSERVACIONES) {
      arrErrors.push("OBSERVACIONES");
    }

    showError(arrErrorsText);

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const showError = (arrErrorsText: any) => {
    if (arrErrorsText.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe considerar lo siguiente:</h3>
            {arrErrorsText.map((e: any) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
  };

  const saveData = async (): Promise<boolean> => {
    let flag = false;
    let requisito = 0;
    if (
      !selectedItemNormativo &&
      selectedItemNormativo !== null &&
      createdItemNormativo?.REQUISITOS_NORMATIVOS !== undefined &&
      createdItemNormativo !== null
    ) {
      let idRequisitoNormativo = createdItemNormativo.REQUISITOS_NORMATIVOS[0];
      let item = requisitoNormativoAuditoria.filter((ua) => ua.ID === idRequisitoNormativo).pop();
      if (item !== undefined) {
        let id = item.ID;
        requisito = id;
      }
    }

    const value: Partial<IItemNormativo> = {
      ID: selectedItemNormativo?.ID,
      ID_AUDITORIA: auditoriaSeleccionada?.ID as number,
      REQUISITOS_NORMATIVOS:
        requisito === 0
          ? Array.from(document.getElementsByName("chkRequisitoNormativo"))
              .filter((rn) => (rn as HTMLInputElement).checked && !(rn as HTMLInputElement).disabled)
              .map((rn) => parseInt((rn as HTMLInputElement).value))
          : [requisito],
      PREDIO_RECINTO: refTxtPredio.current?.value,
      FECHA: moment(refTxtFecha.current?.value || "").toDate(),
      HORA_INICIO: refTxtHoraDesde.current?.value,
      HORA_FINAL: refTxtHoraHasta.current?.value,
      OBSERVACIONES: refTxtObservaciones.current?.value,
      AUTOR: currentUser?.email,
      AUTOR_DISPLAY: currentUser?.fullname,
      FECHA_CREACION: moment().toDate(),
      FECHA_MODIFICACION: moment().toDate(),
    };
    if (formValidation(value)) {
      let result = (await postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_ITEMNORMATIVO}`, value, { Authorization: `Bearer ${token}` })).result;
      console.log("result", result);
      AuditoriaService.GenerarPDFPlan(token, auditoriaSeleccionada?.ID as number);
      flag = true;
    }
    return flag;
  };

  return (
    <div className="row">
      <Offcanvas show={isOpen} onHide={() => callBackClose()} placement={"end"} className="w-50">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Auditoría</Offcanvas.Title>
        </Offcanvas.Header>
        {isLoading ? (
          <Loading />
        ) : (
          <Offcanvas.Body>
            <div className="card bg-light border p-3 pt-2 mt-2">
              <button
                data-testid="btnedit"
                hidden={true}
                onClick={() => {
                  formValidation({});
                  saveData();
                }}></button>
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Ítem Normativo</span>
                  </h6>
                </div>
                {auditoriaSeleccionada?.TIPO_AUDITORIA_ES_PARTICULAR && (
                  <div>
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>Gerencia</label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <Select
                        placeholder="Seleccione"
                        defaultValue={
                          allGerencia
                            .filter((ta) => ta.ID === auditoriaSeleccionada?.ID_GERENCIA_SUBGERENCIA)
                            .map((ta) => {
                              return { value: ta.ID, label: ta.TITULO };
                            })
                            .pop() || ""
                        }
                        className={`${arrErrorEmpty.includes("TIPO_AUDITORIA") && "error"}`}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allTipoAuditoria.map((i) => ({
                          value: i.ID as number,
                          label: i.NOMBRE,
                        }))}
                        isDisabled={true}
                      />
                    </div>
                  </div>
                )}
                {auditoriaSeleccionada?.TIPO_AUDITORIA_ES_PARTICULAR && (
                  <div>
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>Ámbito de Auditoría</label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <div className={`form-control form-control-sm ${arrErrorEmpty.includes("UNIDAD_AUDITAR") && "error"}`}>
                        {allUnidadAuditar
                          .filter((ua) => auditoriaSeleccionada?.UNIDAD_A_AUDITAR.includes(ua.ID as number))
                          .map((ua) => {
                            return (
                              <div key={ua.ID} className="d-flex infoItemNormativo">
                                <input type="checkbox" id={`chk${ua.ID}`} value={ua.ID} checked disabled />
                                <label htmlFor={`chk${ua.ID}`} className="ms-2 fw-normal">
                                  {ua.NOMBRE}
                                </label>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Tema/Ítem
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <div className={`form-control form-control-sm ${arrErrorEmpty.includes("REQUISITOS_NORMATIVOS") && "error"}`}>
                    {selectedItemNormativo === null ? (
                      requisitoNormativoAuditoria
                        .filter((rna) =>
                          auditoriaSeleccionada?.TIPO_AUDITORIA_ES_PARTICULAR
                            ? rna.ID_GERENCIA === auditoriaSeleccionada?.ID_GERENCIA_SUBGERENCIA &&
                              rna.ID_TIPO_AUDITORIA === auditoriaSeleccionada?.ID_TIPO_AUDITORIA
                            : rna.ID_GERENCIA == null && rna.ID_TIPO_AUDITORIA === auditoriaSeleccionada?.ID_TIPO_AUDITORIA
                        )
                        .map((rna) => (
                          <div key={rna.ID} className="d-flex">
                            <input
                              type="checkbox"
                              id={`chk${rna.ID}`}
                              value={rna.ID}
                              name="chkRequisitoNormativo"
                              disabled={
                                (selectedItemNormativo as any)?.REQUISITOS_NORMATIVOS?.includes(rna.ID) ||
                                (createdItemNormativo !== undefined ? createdItemNormativo?.REQUISITOS_NORMATIVOS.includes(rna.ID) : false)
                              }
                              defaultChecked={
                                (selectedItemNormativo as any)?.REQUISITOS_NORMATIVOS?.includes(rna.ID) ||
                                (createdItemNormativo !== undefined ? createdItemNormativo?.REQUISITOS_NORMATIVOS.includes(rna.ID) : false) ||
                                false
                              }
                            />
                            <label htmlFor={`chk${rna.ID}`} className="ms-2 fw-normal">
                              {rna.TITULO}
                            </label>
                          </div>
                        ))
                    ) : (
                      <div>{(selectedItemNormativo as IItemNormativaxAuditoria)?.ITEM_NORMATIVO}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Predio/Recinto
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <textarea
                    className={`form-control form-control-sm ${arrErrorEmpty.includes("PREDIO_RECINTO") && "error"}`}
                    rows={3}
                    ref={refTxtPredio}
                    defaultValue={
                      selectedItemNormativo?.PREDIO_RECINTO ||
                      `${auditoriaSeleccionada?.GERENCIA_SUBGERENCIA}\n${auditoriaSeleccionada?.UNIDAD_PROYECTO}`
                    }
                    onChange={() => {
                      setLenTxtPredio(refTxtPredio.current?.value.length || 0);
                    }}></textarea>
                  <span>{lenTxtPredio}/250</span>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Fecha
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    className={`form-control form-control-sm w-50 ${arrErrorEmpty.includes("FECHA") && "error"}`}
                    type="date"
                    ref={refTxtFecha}
                    defaultValue={moment(selectedItemNormativo?.FECHA).format("yyyy-MM-DD") || ""}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Hora Inicio (hh:mm)
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    className={`form-control form-control-sm w-50 ${arrErrorEmpty.includes("HORA_INICIO") && "error"}`}
                    type="text"
                    ref={refTxtHoraDesde}
                    defaultValue={selectedItemNormativo?.HORA_INICIO}
                    maxLength={5}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Hora Final (hh:mm)
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    className={`form-control form-control-sm w-50 ${arrErrorEmpty.includes("HORA_FINAL") && "error"}`}
                    type="text"
                    ref={refTxtHoraHasta}
                    defaultValue={selectedItemNormativo?.HORA_FINAL}
                    maxLength={5}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Observaciones
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <textarea
                    className={`form-control form-control-sm ${arrErrorEmpty.includes("OBSERVACIONES") && "error"}`}
                    rows={3}
                    ref={refTxtObservaciones}
                    defaultValue={selectedItemNormativo?.OBSERVACIONES}
                    onChange={() => {
                      setLenTxtObservaciones(refTxtObservaciones.current?.value.length || 0);
                    }}
                    maxLength={250}></textarea>
                  <span>
                    <small>{lenTxtObservaciones}/250</small>
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={async () => {
                      setIsSendingData(true);
                      const f = await saveData();
                      if (f) {
                        setIsSendingData(true);
                        callBack();
                      } else {
                        setIsSendingData(false);
                      }
                    }}
                    disabled={isSendingData}>
                    {" "}
                    Grabar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      callBackClose();
                    }}
                    disabled={isSendingData}>
                    Volver
                  </button>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        )}
      </Offcanvas>
    </div>
  );
}
